import React, { useState, useEffect } from 'react';
import './TextToneSelector.css';
import { useTranslation } from 'react-i18next';
import bookopenSVG from '../Iconos/book-open.svg';
import briefcaseSVG from '../Iconos/briefcase.svg';
import smileSVG from '../Iconos/smile-2.svg';
import trending from '../Iconos/trending-up.svg';
import musicSVG from '../Iconos/music.svg';
import voicesData from './voices.json';

type TextToneAndHashtagSelectorProps = {
  onToneChange: (tone: string) => void;
  selectedTone: string;
  onVoiceChange: (voice: string) => void; // Se usará este prop
};

function TextToneAndHashtagSelector({
  onToneChange,
  selectedTone,
  onVoiceChange,  // Asegúrate de que este prop se esté utilizando
}: TextToneAndHashtagSelectorProps) {

  const { t } = useTranslation();
  const [voices, setVoices] = useState<{ value: string, label: string }[]>([]);

  useEffect(() => {
    // Cargar los datos de voces desde el JSON
    setVoices(voicesData);
  }, []);

  return (
    <div className="tones-container">
      <div>
        <div className='text-tone'>
          <div>  <img src={musicSVG} alt="Creativo" className="tone-icon" /></div>
          <div className='tone-text'>{t('Text-tone')}</div>
        </div>
        <div className="tones-row">
          <button
            className={`tone-button creativo ${selectedTone === 'creativo' ? 'active' : ''}`}
            onClick={() => onToneChange('creativo')}
          >
            <img src={bookopenSVG} alt="Creativo" className="tone-icon" />
            {t('Creativo')}
          </button>
          <button
            className={`tone-button negocio ${selectedTone === 'negocio' ? 'active' : ''}`}
            onClick={() => onToneChange('negocio')}
          >
            <img src={trending} alt="Negocio" className="tone-icon" />
            {t('Negocio')}
          </button>
        </div>
        <div className="tones-row">
          <button
            className={`tone-button infantil ${selectedTone === 'infantil' ? 'active' : ''}`}
            onClick={() => onToneChange('infantil')}
          >
            <img src={smileSVG} alt="Infantil" className="tone-icon" />
            {t('Infantil')}
          </button>
          <button
            className={`tone-button formal ${selectedTone === 'formal' ? 'active' : ''}`}
            onClick={() => onToneChange('formal')}
          >
            <img src={briefcaseSVG} alt="Formal" className="tone-icon" />
            {t('Formal')}
          </button>
        </div>
      </div>

      <div className="voice-selector">
        <div className="tone-text">{t('Elige el idioma')}</div>

        {/* Añadir la leyenda aquí */}
        <div className="voice-legend">
          <p>F = Femenino, M = Masculino</p>
        </div>
        <select
          className="voice-dropdown"
          onChange={(e) => onVoiceChange(e.target.value)}  // Aquí nos aseguramos de que el prop se llame correctamente
        >
          {voices.map((voice, index) => (
            <option key={index} value={voice.value}>
              {voice.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default TextToneAndHashtagSelector;
